import type { ManualImportSource } from '../../types';

interface Props {
  source: ManualImportSource;
  onChange: (updated: ManualImportSource) => void;
}

export function ManualSourceEditor({ source, onChange }: Props) {
  return (
    <div>
      <label className="block text-xs font-medium text-gray-600 mb-1">
        Notes
      </label>
      <textarea
        value={source.notes ?? ''}
        onChange={(e) =>
          onChange({ ...source, notes: e.target.value || undefined })
        }
        placeholder="Where do imports for this brand come from? Any quirks?"
        rows={3}
        className="w-full text-sm border border-gray-300 rounded px-2 py-1"
      />
      <p className="text-[11px] text-gray-400 mt-1">
        Manual sources don&apos;t auto-import; use this to document an offline
        process (CSV drops, supplier emails, etc.).
      </p>
    </div>
  );
}
